module.exports = __webpack_public_path__ + "img/onlineTicketing.e15b7552.png";